import { IAccount } from "@wingspanhq/users/dist/lib/interfaces";
import { selectorAccountNumber } from "../../../shared/selectors/selectorAccountNumber";

export type InstantPlaidRoute = {
  path: "instant-plaid" | "instant-plaid-reconnect";
  accounts: IAccount[];
};

/**
 * Decides where a freshly Plaid-linked set of accounts should go in the instant
 * payout flow.
 *
 * Accounts that have account/routing numbers go to the account-select screen
 * (`RouteInstantAccountSelect`) regardless of RTP eligibility — that screen
 * already surfaces the debit-card / wallet / standard fallbacks per selected
 * account. Only accounts genuinely missing numbers go to the reconnect screen,
 * which is the one case that screen's "missing information" messaging fits.
 *
 * Previously the flow routed by `selectorAccountRtpReady` (`canBeUsedFor.rtp`),
 * which dropped payout-eligible-but-RTP-ineligible accounts into the reconnect
 * dead end with no debit-card fallback. See PLA-3106.
 */
export const selectorInstantPlaidRoute = (
  accounts: IAccount[]
): InstantPlaidRoute => {
  const accountsWithNumbers = accounts.filter(selectorAccountNumber);

  return accountsWithNumbers.length > 0
    ? { path: "instant-plaid", accounts: accountsWithNumbers }
    : { path: "instant-plaid-reconnect", accounts };
};
